import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Invite from "@/pages/Invite";
import EventEditor from "@/pages/EventEditor";
import EventManage from "@/pages/EventManage";
import PublicRSVP from "@/pages/PublicRSVP";
import PastWork from "@/pages/PastWork";
import PastWorkManage from "@/pages/PastWorkManage";
import PastWorkEditor from "@/pages/PastWorkEditor";
import FormsList from "@/pages/FormsList";
import FormBuilder from "@/pages/FormBuilder";
import FormResponses from "@/pages/FormResponses";
import EventDocuments from "@/pages/EventDocuments";
import PublicForm from "@/pages/PublicForm";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import ServicesManage from "@/pages/ServicesManage";
import ServiceEditor from "@/pages/ServiceEditor";
import VendorsManage from "@/pages/VendorsManage";
import CategoriesManage from "@/pages/CategoriesManage";

function AppRouter() {
  const location = useLocation();
  // Process the OAuth callback FIRST (synchronously) to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/invite/:token" element={<Invite />} />
      <Route path="/rsvp/:id" element={<PublicRSVP />} />
      <Route path="/event/:eventSlug/:formSlug" element={<PublicForm />} />
      <Route path="/past-work" element={<PastWork />} />
      <Route path="/past-work/manage" element={<ProtectedRoute perm="pastwork"><PastWorkManage /></ProtectedRoute>} />
      <Route path="/past-work/new" element={<ProtectedRoute perm="pastwork"><PastWorkEditor /></ProtectedRoute>} />
      <Route path="/past-work/:id/edit" element={<ProtectedRoute perm="pastwork"><PastWorkEditor /></ProtectedRoute>} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<ServiceDetail />} />
      <Route path="/admin/services" element={<ProtectedRoute perm="marketplace"><ServicesManage /></ProtectedRoute>} />
      <Route path="/admin/services/new" element={<ProtectedRoute perm="marketplace"><ServiceEditor /></ProtectedRoute>} />
      <Route path="/admin/services/:id/edit" element={<ProtectedRoute perm="marketplace"><ServiceEditor /></ProtectedRoute>} />
      <Route path="/admin/vendors" element={<ProtectedRoute perm="marketplace"><VendorsManage /></ProtectedRoute>} />
      <Route path="/admin/service-categories" element={<ProtectedRoute perm="marketplace"><CategoriesManage /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute perm="team"><Admin /></ProtectedRoute>} />
      <Route path="/create" element={<ProtectedRoute><EventEditor /></ProtectedRoute>} />
      <Route path="/edit/:id" element={<ProtectedRoute><EventEditor /></ProtectedRoute>} />
      <Route path="/events/:id/manage" element={<ProtectedRoute><EventManage /></ProtectedRoute>} />
      <Route path="/events/:id/forms" element={<ProtectedRoute><FormsList /></ProtectedRoute>} />
      <Route path="/events/:id/forms/:formId/edit" element={<ProtectedRoute perm="forms"><FormBuilder /></ProtectedRoute>} />
      <Route path="/events/:id/forms/:formId/responses" element={<ProtectedRoute><FormResponses /></ProtectedRoute>} />
      <Route path="/events/:id/documents" element={<ProtectedRoute><EventDocuments /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" offset={76} richColors />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
